import React from 'react';

function CommunicationField({ value, onChange, error }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}
    >
      <label
        htmlFor="comm"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
      
        <select
  name="selection5"
  value={value.selection5}
  onChange={onChange}
  style={{
    flex: "1",
    minWidth: "50px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ba68c8", // Purple border
    fontSize: "1rem",
    background: "linear-gradient(135deg, #f3e5f5, #ce93d8)", // Purple gradient
    color: "#6a1b9a", // Purple font color

    // ❌ Removed appearance overrides to enable default dropdown arrow
    // appearance: "none",
    // WebkitAppearance: "none",
    // MozAppearance: "none",

    boxShadow: "0px 4px 8px rgba(186, 104, 200, 0.4)", // Light purple shadow
    transition: "background-color 0.3s ease",
    cursor: "pointer",
  }}
>
  <option value="Dream">Dream</option>
  <option value="Address">Address</option>
  <option value="Contact">Contact</option>
  <option value="Mail">Mail</option>
  <option value="Comm.">Comm.</option>
</select>


        <input
          type="text"
          name="comm"
          value={value.comm}
          onChange={onChange}
          placeholder="hidden in QR Code"
          style={{
            flex: "2",
            minWidth: "100px",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            boxSizing: "border-box",
          }}
        />
      </label>

      {error && <div style={{ color: "red", fontSize: "12px" }}>{error}</div>}
    </div>
  );
}

export default CommunicationField;
